import React from "react";
import { useGlobalContext } from "./context/globalContext";
import "../index.css";

const AboutDeveloper = () => {
  const { handleShowModal } = useGlobalContext();
  return (
    <section className="section shadow-sm lazyloaded" id="developer">
      {/* <div className="d-block pt-2 pb-1 text-center">
        <img
          src="images/adani-realty-logo.webp"
          width="150px"
          height="70px"
          loading="lazy"
          alt="logo"
        />
      </div> */}
      <div className="row">
        <div className="col-md-8">
          <h2 className="d-block section-heading-sub text-capitalize">
            About Developer
          </h2>
        </div>
        <div className="col-md-4">
          <button
            className="btn btn-info micro-form-btn enqModal effetGradient effectScale download_brochure float-lg-right d-none d-lg-block"
            onClick={handleShowModal}
          >
            Chat with us
          </button>
        </div>
      </div>

      <p>
        Adani Realty, the real estate arm of the globally trusted Adani Group,
        is reshaping Indian skylines with transformative developments built on
        sustainability, innovation, and integrity.
        <br />
        With landmark residential and commercial projects in Mumbai, Ahmedabad,
        Gurugram, and beyond, Adani Realty delivers thoughtfully planned
        ecosystems that reflect modern lifestyles and future-ready
        infrastructure.
        <br />
        The upcoming Adani Realty Sion project is a shining example of the
        brand's vision—blending intelligent design with quality execution to
        create aspirational addresses for modern urban India.
      </p>
      {/* 
      <div className="rera-numbers">
        <div className="rera-item">
          <img src="images/rera-P51800079537.jpeg" alt="rera qr" />
          <strong>P51800079537</strong>
        </div>
      </div> */}

      {/* <span className="pro-rera text-center-mob">
        {project} has been registered via MahaRERA registration number and is
        available on the website{" "}
        <a href="https://maharera.mahaonline.gov.in/">
          https://maharera.mahaonline.gov.in/
        </a>{" "}
        under registered projects.
      </span> */}

      <p></p>
      <button
        className="btn btn-info micro-form-btn enqModal effetGradient effectScale download_brochure float-lg-right mx-sm-auto d-lg-none"
        data-form="lg"
        data-title=" Chat with us"
        data-btn=" Chat with us"
        data-enquiry="Download Brochure Left Panel"
        data-redirect="enquiry"
        data-toggle="modal"
        data-target="#enqModal"
        onClick={handleShowModal}
      >
        Chat with us
      </button>
    </section>
  );
};

export default AboutDeveloper;
